import React, { useEffect, useState } from "react";
import NavBar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import TitleComponent from "../../components/title/title";
import { IoMegaphoneOutline } from "react-icons/io5";
import Post from "../../components/post/post";
import { PostData } from "../../components/post/post";
import PostSecond from "../../components/post/postSecond";
import { Posts, PostsSecond } from "./style";
import { useTranslation } from "react-i18next";
import { useServiceHome } from "../../hooks/serviceHome";

export default function Pronouncement() {
  const { t } = useTranslation();
  const { getPronunciamentos } = useServiceHome();
  const [posts, setPosts] = useState<PostData[]>([]);

  useEffect(() => {
    async function getPosts() {
      await getPronunciamentos()
        .then((response) => {
          setPosts(response?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    getPosts();
  }, []);

  return (
    <>
      <TitleComponent icon={IoMegaphoneOutline} text={t("Pronouncements")} />
      <PostsSecond style={{ marginBottom: "100px" }}>
        {posts.map((post, i) => {
          let even = "p-6 rounded-br-[50px] rounded-tl-[50px] bg-transparent text-black flex items-start pl-3 max-w-3xl h-50 cursor-pointer !border !border-2";
          let odd = "p-6 rounded-bl-[50px] rounded-tr-[50px] bg-[#356405] !text-white flex items-start pl-3 max-w-3xl h-50 cursor-pointer !border !border-2";
          const className = i % 2 == 0 ? even : odd
          return <PostSecond key={post.id} data={post} classNames={className} />;
        })}
      </PostsSecond>
      <Footer />
    </>
  );
}
